module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"remove_field_confirmation":"Are you sure you want to remove this field? This action is irreversible."},"id":{"remove_field_confirmation":"Anda yakin ingin menghapus bidang ini? Bidang ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
